import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class StartupErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    // Suppress errors injected by browser extensions (e.g. Affirm) that fire
    // a native 'submit' event before Angular's FormGroupDirective input bindings
    // are set. These are not application errors.
    const msg = error instanceof Error ? error.message : String(error);
    if (msg.includes('_syncPendingControls')) {
      return;
    }

    if (!environment.production) {
      console.group('Frontend Runtime Error');
      console.error(error);
      console.groupEnd();
      return;
    }

    console.error(error);
  }
}
